import * as z from "zod/v4";

export const getOrCreateTexasSegmentForTeam = {
  name: "getOrCreateTexasSegmentForTeam" as const,
  input: z.object({}),
  output: z.object({ segmentId: z.string() }),
};
